import moment from 'moment'

import { TCron } from './types'

export const calculateNextExecutions = (): null => {
  return null
}

export const parseCronConfig = (values?: TCron | undefined): TCron => {
  if (!values) {
    return {
      cronType: 'daily',
      firstRunTime: moment().toISOString(),
      cronTimes: ['00:00'],
    }
  }

  return { ...values }
}
